import { NgIf } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { MicrFormatDirective } from '@app/shared/directives';

@Component({
	selector: 'micr-input',
	templateUrl: './micr-input.component.html',
	styleUrls: ['./micr-input.component.less'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [MatInputModule, FormsModule, MicrFormatDirective, ReactiveFormsModule, FormlyModule, NgIf],
})
export class FormlyMicrInputComponent extends FieldType<FormlyFieldConfig> {}
